/* libs/oyan-ui/src/lib/containers/info-display/info-display.component.scss */
.info-display__header {
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 2;
}
.info-display.layout {
  height: calc(100vh - 6rem);
  overflow: auto;
}
/*# sourceMappingURL=info-display.component.css.map */
